"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var react_image_lightbox_1 = tslib_1.__importDefault(require("react-image-lightbox"));
var orderBy_1 = tslib_1.__importDefault(require("lodash/orderBy"));
var routes_1 = require("../../routes");
var RouterComponents_1 = require("./RouterComponents");
var Breadcrumbs_1 = require("./Breadcrumbs");
var ProjectPage = /** @class */ (function (_super) {
    tslib_1.__extends(ProjectPage, _super);
    function ProjectPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectPage.prototype.render = function () {
        var project = this.props.store.data.project;
        if (!project) {
            return react_1.default.createElement(RouterComponents_1.NotFoundPage, null);
        }
        return (react_1.default.createElement("div", { className: "project" },
            react_1.default.createElement("div", { className: "section section_less-padding section_grey" },
                react_1.default.createElement("div", { className: "wrapper wrapper_big" },
                    react_1.default.createElement(Breadcrumbs_1.Breadcrumbs, { items: [
                            {
                                name: 'Главная',
                                href: '/',
                            },
                            {
                                name: 'Проекты',
                                href: routes_1.Routes.projects,
                            },
                            {
                                name: project.title,
                            },
                        ] }),
                    react_1.default.createElement("h2", { className: "text-header text-header_h2 text-header_first" }, project.title),
                    react_1.default.createElement("div", { className: "project__description", dangerouslySetInnerHTML: { __html: project.description } }),
                    react_1.default.createElement(Images, { project: project })))));
    };
    ProjectPage = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ProjectPage);
    return ProjectPage;
}(react_1.default.Component));
exports.ProjectPage = ProjectPage;
var Images = function (_a) {
    var project = _a.project;
    var _b = react_1.useState([]), images = _b[0], setImages = _b[1];
    var _c = react_1.useState(null), photoIndex = _c[0], setPhotoIndex = _c[1];
    var someIsVertical = project.images.some(function (i) { return i.height > i.width; });
    var imagesToShow = someIsVertical
        ? orderBy_1.default(project.images, function (i) { return i.height / i.width; }, 'asc')
        : project.images;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "image-grid " + (someIsVertical ? 'image-grid__third' : '') }, imagesToShow.map(function (image, index) { return (react_1.default.createElement("div", { key: image.id, onClick: function () {
                setPhotoIndex(index);
                setImages(imagesToShow.map(function (i) { return i.url; }));
            } },
            react_1.default.createElement("img", { alt: project.title + " - \u0444\u043E\u0442\u043E #" + index, src: image.url }))); })),
        images.length > 0 && (react_1.default.createElement(react_image_lightbox_1.default, { mainSrc: images[photoIndex], nextSrc: images.length > 1 ? images[(photoIndex + 1) % images.length] : undefined, prevSrc: images.length > 1
                ? images[(photoIndex + images.length - 1) % images.length]
                : undefined, onMovePrevRequest: function () {
                return setPhotoIndex((photoIndex + images.length - 1) % images.length);
            }, onMoveNextRequest: function () { return setPhotoIndex((photoIndex + 1) % images.length); }, onCloseRequest: function () { return setImages([]); } }))));
};
